import createDomainSelectors from 'store/createDomainSelectors'
import { initialState } from 'modules/Services/Network/store/reducer'

const { selectSlice, selectField } = createDomainSelectors('services/network', initialState)

export const selectServicesNetwork = selectSlice
// export const selectServicesNetworkLoading = selectField('loading')
// export const selectServicesNetworkAccounts = selectField('accounts')
export const selectServicesNetworkTexts = selectField('texts')
// export const selectServicesNetworkFilters = selectField('filters')
// export const selectServicesNetworkSelection = selectField('selection')
// export const selectServicesNetworkActions = selectField('actions')
